import Sortable from "sortablejs";

export function initializeSortable(elementId, options = {}) {
    const el = document.getElementById(elementId);
    if (el) {
        return Sortable.create(el, options);
    }
    return null;
}
